import React from "react";
import { useFaqsContentQuery } from "../store/services/FaqService";

const Faqs = () => {
	const { data, isLoading } = useFaqsContentQuery();
	let response = data?.response?.data;
	return (
		<>
			<div className="accordion" id="accordionExample">
				{response?.slice(0, 4)?.map((data, index) => {
					return (
						<div
							key={index}
							className="accordion-item wow animate__animated animate__fadeInDown"
						>
							<h2 className="accordion-header" id={"heading" + data?.id}>
								<button
									className="accordion-button"
									type="button"
									data-bs-toggle="collapse"
									data-bs-target={"#collapse" + data?.id}
									aria-expanded={data?.id == 0 ? "true" : "false"}
									aria-controls={"collapse" + data?.id}
								>
									<i className="fa fa-plus" aria-hidden="false"></i>
									<h5>{data?.questions}</h5>
								</button>
							</h2>
							<div
								id={"collapse" + data?.id}
								className={
									data?.id === 1
										? "accordion-collapse collapse show"
										: "accordion-collapse collapse"
								}
								aria-labelledby={"heading" + data?.id}
								data-bs-parent="#accordionExample"
							>
								<div className="accordion-body">
									<p
										dangerouslySetInnerHTML={{
											__html: data?.answers,
										}}
									></p>
								</div>
							</div>
						</div>
					);
				})}
			</div>
		</>
	);
};

export default Faqs;
